module.exports = __webpack_public_path__ + "9c6a62ab0607d3eeed03a1032e014eb2.svg";